import React from "react";

import {
    MInput,
    MLabel,
    MSelect,
    ValidatedForm
} from "components/forms";

import {
    payloadBuilder,
    notNullObjectBuilder,
    enrollmentAdminService, networkErrorHelper
} from "libs";
import { BoxWarning } from "components/misc";

export class EnrollFillFormCLIL extends ValidatedForm {

    PAYLOADS = {
        examSites: [],
        freeCourses: [],
        languages:[{ label: 'selezionare', value: '' }, { label: 'Inglese', value: 'EN' }, { label: 'Spagnola', value: 'ES' }, { label: 'Francese', value: 'FR' }]
    }

    FIELDS_GROUP = [
        [
            {
                field: "idFreeCourse",
                label: "Richiedi Gratuitamente il tuo Omaggio di benvenuto: Iscrizione e partecipazione ad uno dei seguenti Corsi ",
                payload: { options: this.PAYLOADS.freeCourses },
                component: MSelect,
                className: "col-md-12"
            }
        ],
        [
            {
                field: "preferExamOnline",
                label: "Esami a distanza",
                infoText: "Compatibilmente con le norme sanitarie vigenti, in caso di esami a distanza, puoi indicare un Città",
                component: MLabel,
                className: "col-md-12 pt-3"
            }
        ],[
            {
                field: "examSiteOnline",
                label: "Inserisci una città",
                component: MInput,
                className: "col-md-6  pt-3"
            }
        ],
        [
            {
                field: "preferExamPresence",
                label: "Esami in Presenza",
                infoText: "Seleziona una città per l'eventuale esame in presenza",
                component: MLabel,
                className: "col-md-6 pt-3"
            }
        ],[
            {
                field: "examSite",               
                payload: { options: this.PAYLOADS.examSites },
                component: MSelect,
                className: "col-md-6"
            }
        ],[
            {
                field: "language",
                label: "Lingua di rifermento del materiale didattico inerente il Modulo 4 e il Modulo 5",
                payload: { options: this.PAYLOADS.languages },
                component: MSelect,
                className: "col-md-6"
            }
        ]      
    ];

    ERROR_MESSAGES = {
        examSite: 'Specificare una sede esami',
        idFreeCourse: 'Selezionare un corso gratuito',
        language: 'Specificare una lingua'
    };

    validation = {
        examSite: value => value > '',
        idFreeCourse: value => value > '',
        language: value => value > '',
    };

    emptyFields = {
        examSiteOnline: '',
        officeCode: '',
        language: '',
        examSite: 0,
        hasBonusCourse: false,
        idFreeCourse: 0,
    };

    state = {
        loading: true,
        ...this.emptyFields,
        defaultValues: {
            ...this.emptyFields
        }
    };

    constructor(props) {
        super(props);

        // bind event handler to invoke it from child component
        this.onChange = this.onChange.bind(this);
    }

    getPayload = () => {
        return this.payload;
    }

    loadRemote(additionalState = {}) {

        // merge not null values and format dates
        const defaultValues = notNullObjectBuilder(
            this.emptyFields,
            this.props.enrollData,
        );

        const { idExamSession, courseCode } = this.props.enrollData;

        if (this.PAYLOADS.examSites.length < 1) {
            // load paylods to fill the select options 
            enrollmentAdminService.examSites(idExamSession)
                .then(({ data }) => {

                    const { payload } = data;
                    const sites = payload.map(({ value }) => ({ label: value, value: value }));

                    this.PAYLOADS.examSites.unshift({ label: 'Seleziona', value: '' });
                    this.PAYLOADS.examSites.push(...sites);

                    this.setState({
                        examSites: { options: this.PAYLOADS.examSites }
                    });

                })
                .catch(errors => {
                    console.log(errors);
                    networkErrorHelper.notify(errors);
                });
        }

        if (this.PAYLOADS.freeCourses.length < 1) {
            // load paylods to fill the select options 
            enrollmentAdminService.freeCourses(courseCode)
                .then(({ data }) => {

                    const { payload } = data;
                    const courses = payload.map(({ id, title }) => ({ label: title, value: id }));

                    this.PAYLOADS.freeCourses.unshift({ label: 'Seleziona corso', value: 0 });
                    this.PAYLOADS.freeCourses.push(...courses);

                    this.setState({
                        esamSites: { options: this.PAYLOADS.esamSites }
                    });

                })
                .catch(errors => {
                    console.log(errors);
                    networkErrorHelper.notify(errors);
                });
        }
        const newState = {
            defaultValues,
            loading: false,
            ...additionalState,
        };

        this.setState(newState);
    }

    saveRemote = () => {

        this.payload = payloadBuilder(this.state);
        const { idFreeCourse, language } = this.state.defaultValues;

        this.payload.pluginConfig = {language: language};
        
        if (idFreeCourse) {
            this.payload.hasBonusCourse=true;
            const courses = this.PAYLOADS.freeCourses.filter(item => (item.value === idFreeCourse));           
            if (courses) {
                this.payload.titleFreeCourse = courses[0].label;
            }
        } else {
            this.payload.titleFreeCourse = '';
            this.payload.hasBonusCourse=false;
        }

        const validations = {
            examSite: null,
        }

        this.setState({ formActive: false, ...validations });
    };

    render() {

        const { loading, defaultValues } = this.state;
        if (loading) return <></>;

        const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

        return (<>
            {code}
            <BoxWarning><b>ATTENZIONE:</b><br/>
            La scelta della lingua &egrave; di riferimento irreversibile ed una volta effettuata la selezione non potr&agrave; pi&ugrave; essere cambiata.<br/>
            Eventualmente potr&agrave; accedere ad una lingua diversa da quella confermata solo dopo il pagamento di una mora di euro 300,00 (Trecento/00).</BoxWarning>
        </>);
    }
}